<div *ngIf="entity" class="mx-6 my-4">
  <div class="mb-4">
    <sl-label size="large" style="--line-height--large: var(--sl-input-height-small)" i18n>Audit</sl-label>
  </div>

  <sl-menu-divider></sl-menu-divider>


  <div class="audit-details">
    <sl-label class="audit-details__created" size="small">{{createdDetails}}</sl-label>
    <sl-label class="audit-details__updated" size="small">{{updatedDetails}}</sl-label>
    
  </div>

  <sl-divider></sl-divider>
  <ng-container *ngFor="let change of changes">
    <sl-label size="x-small" weight="bold">{{change.commitMetadata.commitDate | date:'medium'}}</sl-label>
    <sl-label size="x-small" class="mb-1" i18n>{{getAuditName(change.commitMetadata.author)}}: {{change.propertyName}} from {{change.left}} to {{change.right}}</sl-label>
  </ng-container>
  
</div>